// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2uT_E","file":"styles_file__2QAGb"};